import type { FaireProductEntity } from "../../entity_types/product";

export const p_nd5h7dycgw: FaireProductEntity = {
  token: "p_nd5h7dycgw",
  type: "product",
  name: "Fallen Candle",
  brandToken: "b_rk82ea6pnc",
  brandName: "Smeli",
  imageUrl:
    "https://cdn.faire.com/fastly/9425d4a1a94fab07bf0410728ceeaf0a8410f2467ed6426ffc4a135403d92f21.png",
  galleryImageUrls: [],
  priceDollars: 14,
  description:
    "Fallen is a 9 oz single wick candle in a black glass vessel, finished with our signature die cut illustrated label.\n\nWarm maple and cinnamon melt into creamy milk and soft orange blossom, grounded by smooth sandalwood, vanilla, and powdery heliotrope. Warm, delicate, and quietly nostalgic, Fallen feels like wandering beneath the trees just after dusk, gathering little treasures from the forest floor.\n\nGolden. Wooded. Soft.\n\nMaple | Cinnamon | Orange Blossom | Sandalwood | Vanilla | Heliotrope\n",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:03.097Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
